import { render, staticRenderFns } from "./account1.vue?vue&type=template&id=4b974b98&scoped=true"
import script from "./account1.vue?vue&type=script&lang=js"
export * from "./account1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b974b98",
  null
  
)

export default component.exports